import { CanMatchFn } from '@angular/router';
import { inject } from '@angular/core';
import { Permissions as PermissionsService } from '@customer/services/permissions.svc';
import { Observable, Subscriber } from 'rxjs';

export const gatheringAndProcessing: CanMatchFn = () => {
  const permissionsSvc = inject(PermissionsService);
  const rolesSvcFnChecks: (keyof PermissionsService)[] = [
    'hasPortalAdminRole',
    'hasGasSettlementRole',
    'hasCheckDetailsRole',
    'hasMeasuredVolumesRole',
    'hasOutagesRole',
    'hasOutagesEmployeeRole',
    'hasInvoicesRole',
    'hasNGGPBusinessSegment'
  ];
  const hasGatheringAndProcessingAccess$ = new Observable<boolean>((subscriber: Subscriber<boolean>) => {
    let isVerdict = false;
    for (const roleSvcFn of rolesSvcFnChecks) {
      const roleSvcCheck = permissionsSvc[roleSvcFn] as unknown as (() => boolean) | boolean | undefined;
      if (typeof roleSvcCheck === 'function') {
        if (roleSvcCheck.call(permissionsSvc)) {
          isVerdict = true;
          break;
        }
      } else if (roleSvcCheck) {
        isVerdict = true;
        break;
      }
    }
    subscriber.next(isVerdict);
    subscriber.complete();
  });
  return hasGatheringAndProcessingAccess$;
};
